import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InfoAlertService {
  private subject = new Subject<any>();
  private keepAfterNavigationChange = false;

  constructor(private router: Router) {
    // clear alert message on route change
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterNavigationChange) {
          // only keep for a single location change
          this.keepAfterNavigationChange = false;
        } else {
          // clear alert
          this.subject.next('');
        }
      }
    });
  }

  /**
   * @description Based on the input it will show the success message.
   * @param {string} message
   * @param {boolean} [keepAfterNavigationChange=false]
   * @memberof InfoAlertService
   */
  infosuccess(message: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: 'infosuccess', text: message });
  }

  /**
   * @description Based on the input it will show the error message.
   * @param {string} message
   * @param {boolean} [keepAfterNavigationChange=false]
   * @memberof InfoAlertService
   */
  infoerror(message: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: 'infoerror', text: message });
  }

  /**
   * @description Based on the input it will remove the message.
   * @param {string} message
   * @param {boolean} [keepAfterNavigationChange=false]
   * @memberof InfoAlertService
   */
  remove(message: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({});
  }

  /**
   * @description Based on the input it will get the message.
   * @returns {Observable<any>}
   * @memberof InfoAlertService
   */
  getMessageInfo(): Observable<any> {
    return this.subject.asObservable();
  }
}
